import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'desktop-bl-sidebar',
  template: `
    <desktop-shipment-details-bl [isSideBar]="true" (dataSaved)="dataSaved.emit()"></desktop-shipment-details-bl>
  `,
  styleUrls: ['./desktop-bl-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopBlSidebarComponent {
  @Output() public dataSaved: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}
